import { FeetKeyPoint } from '../../api/gql/graphql';
import { ImageNames } from '../../services/asset-src-controller';

export enum CapturingStage {
  Capture1 = 'capture1',
  Instruction = 'instruction',
  Capture2 = 'capture2',
}

export enum View {
  View1 = 'view1',
  View2 = 'view2',
}

export enum ScannerVariant {
  Assisted = 'assisted',
  Solo = 'solo',
}

export const imageName = (
  view: View,
): ImageNames.PoseImage1 | ImageNames.PoseImage2 => {
  switch (view) {
    case View.View1: {
      return ImageNames.PoseImage1;
    }
    case View.View2: {
      return ImageNames.PoseImage2;
    }
  }
};

export const expectedKeyPoints = (view: View): FeetKeyPoint[] => {
  switch (view) {
    case View.View1: {
      return [
        FeetKeyPoint.RightHeel,
        FeetKeyPoint.LeftToe,
        FeetKeyPoint.RightToe,
      ];
    }
    case View.View2: {
      return [
        FeetKeyPoint.LeftHeel,
        FeetKeyPoint.LeftToe,
        FeetKeyPoint.RightToe,
      ];
    }
  }
};

export const formatAsJpeg = (imageBlob: Blob): File => {
  return new File([imageBlob], 'image.jpg', { type: 'image/jpeg' });
};
